import type { ImporterDescriptor } from './types';
import productAllInOneImport from '../pages/imports/productAllInOneImport/descriptor';
import portfolioProductExternalIdImport from '../pages/imports/portfolioProductExternalIdImport/descriptor';
import productMasterListImport from '../pages/imports/productMasterListImport/descriptor';
import productExternalIdImport from '../pages/imports/productExternalIdImport/descriptor';
import partnerAliasImport from '../pages/imports/partnerAliasImport/descriptor';
import productListImport from '../pages/imports/productListImport/descriptor';
import profileDataImport from '../pages/imports/profileDataImport/descriptor';
import elabelsUpdateImport from '../pages/imports/elabelsUpdateImport/descriptor';
import productImport from '../pages/imports/productImport/descriptor';
import productDataImport from '../pages/imports/productDataImport/descriptor';
import productMasterListSync from '../pages/imports/productMasterListSync/descriptor';
import productCreationImport from '../pages/imports/productCreationImport/descriptor';

const descriptors: ImporterDescriptor[] = [
  productAllInOneImport,
  portfolioProductExternalIdImport,
  productMasterListImport,
  productExternalIdImport,
  partnerAliasImport,
  productListImport,
  profileDataImport,
  elabelsUpdateImport,
  productImport,
  productDataImport,
  productMasterListSync,
  productCreationImport,
];

export function getDescriptors(): ImporterDescriptor[] {
  // Return a shallow copy so callers can sort/slice without mutating the
  // module-level registry. The descriptor objects themselves are still
  // shared — they're treated as read-only.
  return descriptors.slice();
}

export function getActiveDescriptors(): ImporterDescriptor[] {
  return descriptors.filter((d) => d.status === 'active');
}

export function getDescriptor(id: string): ImporterDescriptor | undefined {
  return descriptors.find((d) => d.id === id);
}

export type { ImporterDescriptor } from './types';
